// Category selector component for issue creation
// Reference: spec.md US1 - select issue category

import { Select, FormField } from '../ui';
import type { IssueCategory } from '@propman/shared';

export interface CategorySelectProps {
  value: string;
  onChange: (category: string) => void;
  error?: string | undefined;
  required?: boolean | undefined;
}

// Category options with labels
const CATEGORY_OPTIONS: { value: IssueCategory; label: string }[] = [
  { value: 'mechanical', label: 'Mechanical' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'handyman', label: 'Handyman' },
  { value: 'cleaning', label: 'Cleaning' },
  { value: 'security_access', label: 'Security & Access' },
  { value: 'fire_safety', label: 'Fire Safety' },
  { value: 'lift_elevator', label: 'Lift / Elevator' },
  { value: 'pest_control', label: 'Pest Control' },
  { value: 'landscaping_grounds', label: 'Landscaping & Grounds' },
  { value: 'appliances', label: 'Appliances' },
  { value: 'it_intercom', label: 'IT & Intercom' },
  { value: 'other', label: 'Other' },
];

export function CategorySelect({ value, onChange, error, required }: CategorySelectProps) {
  return (
    <FormField
      label="Category"
      htmlFor="category"
      error={error}
      required={required}
      hint="Select the type of issue you're reporting"
    >
      <Select
        id="category"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        required={required}
      >
        <option value="">Select a category...</option>
        {CATEGORY_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </FormField>
  );
}

export default CategorySelect;
